import { createSlice } from '@reduxjs/toolkit';
import FJConstant from '../../constants/FJConstant';

export const FJSliceModals = createSlice({
    name: 'modals',
    initialState: {
        warningModalData: {
            title: '',
            content: '',
            display: false,
            footerDates: [],
        },
        previewModalData: {
            data: {},
            display: false,
        },
        upgradeModalData: {
            display: false,
        },

        uploadImageAsPromptModalData: {
            display: false,
        },

        loadingModalData: {
            display: false,
            message: '',
        },
        mobilePreviewData: {
            data: {},
            display: false,
        },

        upgradeTipsModalData: {
            data: {},
            display: false,
        },

        mobileSimplePreviewData: {
            data: {},
            display: false,
        },
        addAsEditPageModalBtuStatus: FJConstant.SUCCESS,
        globalLoadingDisplay: false,
        mobileFooterModalData: {
            title: '',
            children: null,
            hasMask: '',
            display: false,
        },
        isShowRecordDisplay: false,
        addMediaLibraryInfo: {
            visible: false,
            list: [],
        },
        autoSelectionNoticeDisplay: false,

        videoTrimModelData: {
            display: false,
            data: {
                // src: 'https://www.smartvideomaker.com/ai/export/video-background-remove/150472aa6346b9816ffc74cd6e3cbf7b.webm',
                // width: 1920,
                // height: 1080,
                // duration: 10,
            },
        },
        serverBusyModalData: {
            display: false,
        },
        animateImageModalDisplay: false,
        timeDiscountPanelData: {
            visible: false,
        },
        timeDiscountSelectedIndex: 1,

        progressModalData: { display: false, cancelCallback: null },
        progress: 0,
    },
    reducers: {
        setProgressAction: (state, action) => {
            state.progress = action.payload;
        },
        setProgressModalData: (state, action) => {
            state.progressModalData = action.payload;
        },
        setSliceWarningModalData: (state, action) => {
            state.warningModalData = action.payload;
        },
        setSlicePreviewModalData: (state, action) => {
            state.previewModalData = action.payload;
        },
        setSliceUpgradeModalData: (state, action) => {
            state.upgradeModalData = action.payload;
        },
        setSliceUploadImageAsPromptModalData: (state, action) => {
            state.uploadImageAsPromptModalData = action.payload;
        },
        setSliceAddAsEditPageModalBtuStatus: (state, action) => {
            state.addAsEditPageModalBtuStatus = action.payload;
        },
        setSliceLoadingModalData: (state, action) => {
            state.loadingModalData = action.payload;
        },
        setSliceMobilePreviewData: (state, action) => {
            state.mobilePreviewData = action.payload;
        },
        setGlobalLoadingDisplay: (state, action) => {
            state.globalLoadingDisplay = action.payload;
        },
        setMobileFooterModalData: (state, action) => {
            state.mobileFooterModalData = action.payload;
        },
        setSliceUpgradeTipsModalData: (state, action) => {
            state.upgradeTipsModalData = action.payload;
        },
        setMobileSimplePreviewData: (state, action) => {
            state.mobileSimplePreviewData = action.payload;
        },
        setSliceIsShowRecordDisplay: (state, action) => {
            state.isShowRecordDisplay = action.payload;
        },
        setMediaLibraryInfo: (state, action) => {
            state.addMediaLibraryInfo = action.payload;
        },
        setAutoSelectionNoticeDisplay: (state, action) => {
            state.autoSelectionNoticeDisplay = action.payload;
        },
        setVideoTrimModelData: (state, action) => {
            state.videoTrimModelData = action.payload;
        },
        setServerBusyModalData: (state, action) => {
            state.serverBusyModalData = action.payload;
        },
        setAnimateImageModalDisplay: (state, action) => {
            state.animateImageModalDisplay = action.payload;
        },
        setTimeDiscountPanelData: (state, action) => {
            state.timeDiscountPanelData = action.payload;
        },
        setTimeDiscountSelectedIndex: (state, action) => {
            state.timeDiscountSelectedIndex = action.payload;
        },
    },
});

export const {
    setProgressAction,
    setSliceWarningModalData,
    setSlicePreviewModalData,
    setSliceUpgradeModalData,
    setSliceUploadImageAsPromptModalData,
    setSliceAddAsEditPageModalBtuStatus,
    setSliceLoadingModalData,
    setSliceMobilePreviewData,
    setGlobalLoadingDisplay,
    setMobileFooterModalData,
    setSliceUpgradeTipsModalData,
    setMobileSimplePreviewData,
    setSliceIsShowRecordDisplay,
    setMediaLibraryInfo,
    setAutoSelectionNoticeDisplay,
    setVideoTrimModelData,
    setServerBusyModalData,
    setAnimateImageModalDisplay,
    setTimeDiscountPanelData,
    setTimeDiscountSelectedIndex,
    setProgressModalData,
} = FJSliceModals.actions;

export default FJSliceModals.reducer;
